import Link from 'next/link';
import React, { FC } from 'react';

import imageHelper from '@/src/assets/helpers/imageHelper';
import { ITheme } from '@/src/assets/interfaces/themeInterface';

import NextImage from '../UI/nextImage/NextImage';
import NextLink from '../UI/nextLink/NextLink';
import { Title } from '../UI/title/Title';

import styles from './LatestCard.module.scss';

type TCard = {
    theme: Partial<ITheme>;
};

const LatestCard: FC<TCard> = ({ theme }) => {
    return (
        <>
            {theme && (
                <article className={styles.card}>
                    <Link href={`/themes/${theme.slug}`} className={styles.card__demos}>
                        <div className={styles.card__desktop}>
                            <NextImage
                                src={`${imageHelper(theme.themeDesktop).url}`}
                                alt={`${theme.title} Desktop`}
                                fill
                                sizes="(max-width: 475px) 75vw, (max-width: 768px) 35.5vw, (max-width: 1200px) 40vw, 492px"
                                style={{ objectFit: 'cover', objectPosition: 'top center' }}
                            />
                        </div>
                    </Link>
                    <div className={styles.card__info}>
                        <div>
                            <Link
                                href={`/themes/${theme.slug}`}
                                className={`heading__5 ${styles.card__name}`}>
                                <Title text={theme.title!} size="xs" />
                            </Link>
                            <p className={`excerpt body-md ${styles.card__excerpt}`}>
                                {theme.excerpt}
                            </p>
                        </div>
                        <NextLink
                            href={`/themes/${theme.slug}`}
                            ariaLabel={`Explore ${theme.title}`}
                            className={styles.card__link}>
                            Explore {theme.title}
                        </NextLink>
                    </div>
                </article>
            )}
        </>
    );
};

export default LatestCard;
